<template>
    <div style="max-width: 770px;">
        
        <Steps steps="4" current="5" links="true" />
        <form @submit.prevent="validateBeforeSubmit">
            <div class="txt-grey">Final Step</div>
            <h3 class="uc">Bank Information</h3>
            <p class="light mb-4">Tell us where you'd like to have your money deposited.</p>
             <fieldset class="mb-5">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <div class="form-group mb-0">
                            <div class="mt-3 mb-2 check-label">What's your account type?</div>                           
                            <div class="radio-options">
                                <div class="radio-option" :class="bankAccountType == 'checking' ? 'selected' : ''" @click="bankAccountType='checking'">
                                    Checking Account
                                </div>
                                <div class="radio-option align-items-center" :class="bankAccountType == 'saving' ? 'selected' : ''" @click="bankAccountType='saving'">
                                    Savings Account
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             </fieldset>
             
             <fieldset class="mb-3">
                <div class="mb-3">
                    <img src="/images/check.png" alt="Bank Check" class="img-fluid">
                </div>
                <div class="row">
                    <div class="col-lg-5 col-xl-4">
                        <CleaveInput
                            label="ABA / Bank routing number"
                            id="bankRoutingNumber"
                            name="bankRoutingNumber"
                            maxlength="9"
                            type="tel"
                            :cleaveoptions="masks.aba"
                            v-model="bankRoutingNumber"
                            v-validate="'required|validateABA'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('bankRoutingNumber')" 
                        />
                    </div>
                    <div class="col-lg-5 col-xl-4">
                        <BasicInput
                            label="Bank account number"
                            id="bankAccountNumber"
                            name="bankAccountNumber"
                            type="tel"
                            autocomplete="off"
                            v-model="bankAccountNumber"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('bankAccountNumber')" 
                        />
                    </div>
                </div>
             </fieldset>
             <fieldset class="mb-3">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your bank's name?"
                            id="bankName"
                            name="bankName"
                            v-model="bankName"
                            v-validate="'required'"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('bankName')" 
                        />
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="How long have you had the account?"
                            id="monthsAtBank"
                            name="monthsAtBank"
                            v-model="monthsAtBank"
                            v-validate="'required'"
                            :options="[{value: '84', label: '7 years or more'}, {value: '72', label: '6 years'}, {value: '60', label: '5 years'}, {value: '48', label: '4 years'}, {value: '36', label: '3 years'}, {value: '24', label: '2 years'}, {value: '12', label: 'One year or less'}]"
                            errormsg="This is a required field"
                            :error="errors.first('monthsAtBank')" 
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <CleaveInput
                            label="What's your SSN?"
                            id="ssn"
                            name="ssn"
                            type="tel"
                            maxlength="11"
                            autocomplete="off"
                            :cleaveoptions="masks.ssn"
                            v-model="ssn"
                            help="Lenders require this information in order to verify your identity and keep your identity safe"
                            v-validate="{ required: true, regex: /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/ }"
                            :exval="validationAttempt"
                            errormsg="This is a required field"
                            :error="errors.first('ssn')" 
                        />
                    </div>
                </div>
 
             </fieldset>

            <div class="light txt-grey p14">Clicking “Submit Loan Request” is my e-signature whereby I consent to the <a href="/legal/privacy" target="_blank">Privacy Policy</a>, <a href="/legal/tos" target="_blank">Terms of Use</a>, <a href="/legal/e-consent" target="_blank">E-Consent</a> and <a href="/legal/disclaimer" target="_blank">Disclaimer</a> and to allow you and <a href="/legal/partners" target="_blank">these companies</a> to use automated methods to send marketing calls or texts to <strong>{{formData.phone}}</strong>, my number that I provided, even if it's on a do not call list. I agree my consent is not a condition to get a loan or other services offered by lenders and related (like pre-paid card, debt relief) providers in your network. I can <a href="/unsubscribe/phone" target="_blank">opt-out of your telemarketing</a> at any time.</div>

            <div class="my-5 d-flex align-items-center flex-wrap">
                <button class="btn btn-cta btn-red uc" :disabled="saving" id="form-submit-long">{{saving ? 'Sending Your Request...' : 'Submit Loan Request'}}</button>
                <div v-if="saving" class="mt-3 mt-md-0 ml-auto ml-md-3 mr-auto mr-md-0">
                    <div class="dots">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
                <div v-if="errorMessage" class="alert alert-danger w-100 mt-4">
                    There was an error submitting your application. Please try again later.
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
import Select from '@/components/form/Select.vue';
import Steps from '@/components/form/Steps.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'FormStep5',
    title: 'Register | Step 5',
    components:{
        BasicInput,
        CleaveInput,
        Select,
        Steps,
    },
    data() {
	  return {
            saving: false,
            validationAttempt: false,
            errorMessage: false,

            bankAccountType: 'checking',
            bankRoutingNumber: '',
            bankAccountNumber: '',
            bankName: '',
            monthsAtBank: '',
            ssn: '',

            masks: {
                ssn: { numericOnly: true, delimiter: '-', blocks: [3, 2, 4] },
                aba: { numericOnly: true, blocks: [9] },
            }

		}
    },
    methods: {
        ...mapActions(['saveFormData', 'sendToAPI']),
        
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'bankAccountType': this.bankAccountType,
                        'bankRoutingNumber': this.bankRoutingNumber,
                        'bankAccountNumber' : this.bankAccountNumber,
                        'bankName' : this.bankName,
                        'monthsAtBank' : this.monthsAtBank,
                        'ssn' : this.ssn,
						'fifthStep': true,
                    });
                    
                    //Send to API replaced with push to Processing
                    this.$router.push({ path: '/registration/processing' });
                } else {
                    this.saving = false;
                }
              });
              
        }
    },
    computed: {
        ...mapGetters(["formData"]),
        VUE_APP_SITE_URLNAME(){
            return process.env.VUE_APP_SITE_URLNAME
        }
    },
    created(){
        this.bankAccountType = this.formData.bankAccountType || 'checking';
        this.bankRoutingNumber = this.formData.bankRoutingNumber || '';
        this.bankAccountNumber = this.formData.bankAccountNumber || '';
        this.bankName = this.formData.bankName || '';
        this.monthsAtBank = this.formData.monthsAtBank || '';
        this.ssn = this.formData.ssn || '';
  }
}

</script>